(() => {
    // slick default setting
    let defaultSettings = {
        loop: true,
        speed: 700,
        effect: "fade",
        fadeEffect: {
            crossFade: true
        },
        autoplay: {
            delay: 7000,
            disableOnInteraction: false
        }
    };

    function initialize(swiper) {
        if (swiper.swiper)
            return;

        new Swiper(swiper, Object.assign({}, defaultSettings, swiper.dataset.swiper ? JSON.parse(swiper.dataset.swiper) : {}));
    }

    document.querySelectorAll(".swiper-slider").forEach(el => initialize(el));

    new MutationObserver(mutations => {
        mutations.forEach(mutation => {
            mutation.addedNodes.forEach(node => {
                if (node.nodeType !== 1)
                    return;

                node.matches(".swiper-slider") && initialize(node);

                node.querySelectorAll(".swiper-slider").forEach(el => initialize(el));
            });
        });
    }).observe(document.body, { childList: true, subtree: true });
})();